module.exports = __webpack_public_path__ + "static/firefox-3a8b9d52063e855c00ff68904ffc9ab4.svg";